import { ProductLabel } from "domain/core/types";
export const ROUTES = {
  root: "/join",
  address: "/join/:signUpUUID?",
  details: "/join/details",
  payment: "/join/payment",
  complete: "/join/complete",
};

interface Map {
  [key: string]: string | undefined;
}

export const PAGE_LABELS: Map = {
  "/join": "Join form - Address search",
  "/join/details": "Join form - Details",
  "/join/payment": "Join form - Payment",
  "/join/complete": "Join form - Complete",
};

// matches equivalent check in Plan Chooser
export const INCLUSIVE = "inclusive";
export const EXCLUSIVE = "exclusive";

export const MONTH = "month";
export const CONTENT_SLUG_TO_THEME_MAPPINGS = {
  business: "black",
  flat: "charlie",
  off_peak: "alpha",
  wholesale: "delta",
};

export const PRODUCT_LABELS: ProductLabel = {
  off_peak: "Off Peak",
  flat: "Flat",
  // Whole sale is disabled for the time being while spot prices are high
  // freestyle: "Wholesale",
  business: "Business",
};
